import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p-2" }
const _hoisted_2 = { class: "text-title-underline" }
const _hoisted_3 = { class: "text-subtitle-underline" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "flex items-center justify-end mt-4" }
const _hoisted_6 = { class: "bg-yellow-500 hover:bg-yellow-600 text-white button-pill" }
const _hoisted_7 = { class: "bg-blue-500 hover:bg-blue-600 text-white button-pill" }
const _hoisted_8 = {
  key: 0,
  class: "bg-gray-500 text-white button-pill"
}
const _hoisted_9 = {
  key: 1,
  class: "bg-gray-500 text-white button-pill"
}
const _hoisted_10 = { class: "flex items-center justify-center mt-10" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" セミナー情報はありませんでした。 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_pagination = _resolveComponent("base-pagination")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      _createVNode(_component_layouts_auth_width, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.t('seminar.title')), 1),
            (_ctx.toArray(_ctx.seminars).length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedList, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id,
                      class: "card-outlined p-4 mb-2"
                    }, [
                      _createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1),
                      _createElementVNode("div", {
                        class: "v-html whitespace-pre-wrap",
                        innerHTML: item.summary
                      }, null, 8, _hoisted_4),
                      _createElementVNode("div", _hoisted_5, [
                        (item.open_at)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (item.seminar_user)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: `/seminar/${item.id}`,
                                    class: "text-link"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", _hoisted_6, _toDisplayString(_ctx.t('seminar.button.confirm')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    (_ctx.isOpen(item.open_at) && !_ctx.isClosed(item.closed_at))
                                      ? (_openBlock(), _createBlock(_component_router_link, {
                                          key: 0,
                                          to: `/seminar/${item.id}`,
                                          class: "text-link"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("button", _hoisted_7, _toDisplayString(_ctx.t('seminar.button.apply')), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"]))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          (_ctx.isClosed(item.closed_at))
                                            ? (_openBlock(), _createElementBlock("button", _hoisted_8, _toDisplayString(_ctx.t('seminar.button.closed')), 1))
                                            : (!_ctx.isOpen(item.open_at))
                                              ? (_openBlock(), _createElementBlock("button", _hoisted_9, _toDisplayString(_ctx.t('seminar.button.before_open')), 1))
                                              : _createCommentVNode("", true)
                                        ], 64))
                                  ], 64))
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_base_pagination, {
                      pagedList: _ctx.pagedList,
                      "onUpdate:pagedList": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagedList) = $event)),
                      originalList: _ctx.seminars,
                      pageSize: _ctx.pageSize
                    }, null, 8, ["pagedList", "originalList", "pageSize"])
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_11
                ], 64))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}